<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,computed,watch } from 'vue'
import TextBox from "../../compositions/TextBox.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import ModalAppDialog from "../../compositions/ModalAppDialog.vue";
import PrescriptAnalyzeListComponent from "../Common/PrescriptAnalyzeListComponent.vue";
import OrderPackComponent from "../Common/OrderPackComponent.vue";
import PharmacyMedicineTagComponent from "../Common/PharmacyMedicineTagComponent.vue";
import CustomEvent from "../../compositions/CustomEvent.vue";
import config from "../../config.js";
import { confirmAlertApp, errorAlertApp, successAlertApp } from "../../plugins/alert_app";
import { getPharmacyWholesalerList } from "../../plugins/pharmacy";
import { screenTransition,callBarcode,callSound,authCheck } from "../../plugins/flutter";
import moment from "moment";
import axios from '../../plugins/axios.ts';
import qs from 'qs';
import { useOrderStore } from '../../stores/order';
import { deepCopy } from '../../plugins/utility.ts';
import { uuid } from 'vue-uuid';

const order = useOrderStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    user:{
      type:Object,
      required:true,
    },
    medicine:{
      type:Object,
      default: () => {
          return null;
      }
    },
    isError:{
      type:Boolean,
      required:true,
    },
    currentPharmacyMedicineId:{
      type:Number,
      required:true,
    },
    wholesalers:{
      type:Array,
      required:true,
    },
    staffId:{
      type:Number,
      required:true,
    },
    viewMode:{
      type:Number,
      required:true,
    },
})

const stockType = ref(config.STOCK_TYPES['VAN']);
const pharamcyMedicineId = ref(props.currentPharmacyMedicineId);
const setSelectWholesalerId = (value) => {
  selectWholesalerId.value = 0;
  let records = getPharamcyMedicineList();
  for (let i=0;i<records.length;i++) {
    if (records[i].id == value) {
      selectWholesalerId.value = records[i].wholesaler_id;
      break;
    }
  }
}
watch(pharamcyMedicineId,(newValue,oldValue) => {
  setSelectWholesalerId(newValue);
})
const isErrorDialog = ref(props.viewMode == 0 ? props.isError : false);
const isOrderDialog = ref(false);
const showOrderDialog = () => {
  isOrderDialog.value = true;
}
const closeOrderDialog = () => {
  isOrderDialog.value = false;
}
const deliveryDate = ref('');
const onChangeDeliveryDate = (value) => {
  deliveryDate.value = value;
}
const orderMedicine = reactive([]);
if (props.isError == false && props.medicine != null) {
  orderMedicine.push(props.medicine);
}
const closeErrorDialog = () => {
  isErrorDialog.value = false;
}
const isLoading = ref(false);
const updateOrderConfirm = async () => {
  if (order.get_editing_ids('is_auto').length == 0) {
    errorAlertApp('発注するものがありません。');
    return;
  }
  let result = await confirmAlertApp('発注しますか？');
  if (result.isConfirmed) {
    await checkOrder()
  }
}
const checkOrder = async () => {
  isLoading.value = true;
  try {
    let params = {refresh_datetime:moment(order.refresh_datetime).format('YYYY-MM-DD HH:mm:ss')};
    const paramsSerializer = (params) => qs.stringify(params);
    const response = await axios.get(props.apis.pharmacy_order_check,{params:params,paramsSerializer});
    if (response.data.check_result != null && response.data.check_result) {
      let result = await confirmAlertApp('作業開始後に別端末で発注作業が行われた可能性があります。このまま発注しますか？');
      if (result.isConfirmed) {
        await updateOrder();
      }
    } else {
      await updateOrder();
    }
  } finally {
    isLoading.value = false;
  }
}
const updateOrder = async () => {
  isLoading.value = true;
  let params = order.create_order_params(deliveryDate.value);
  try {
    const response = await axios(props.apis.pharmacy_order_update,{method:"post",data:params});
    if (response.data.status == 200) {
      //TOP画面に遷移
      screenTransition(config.SPAPP_MENU['HOME']);
    }
  } finally {
    isLoading.value = false;
  }
}
const isHoverPrescripFlg = ref(false);
const hoverPrescriptYjCode = ref('');
const hoverPrescriptIdentityId = ref(0);
const leavePrescript = () => {
  isHoverPrescripFlg.value = false;
}
const showHoverPrescript = (yjCode) => {
  if (isHoverPrescripFlg.value == false) {
    hoverPrescriptYjCode.value = yjCode;
  }
  isClosing.value = true;
  hoverPrescriptIdentityId.value++;
  isHoverPrescripFlg.value = !isHoverPrescripFlg.value;
}
const onPredictCoverComplete = () => {
}
const deleteOrderMedicineConfirm = async (stockType,tmpId) => {
  let result = await confirmAlertApp('削除しますか？');
  if (result.isConfirmed) {
    await deleteOrderMedicine(stockType,tmpId);
  }
}
const deleteOrderMedicine = async (stockType,tmpId) => {
  order.delete_data((stockType == config.STOCK_TYPES['VAN'] ? 'is_auto' : 'is_auto_pack'),tmpId,'tmp_id');
}
const {element,isClosing,clickOutside} = CustomEvent(leavePrescript)
onBeforeUnmount(() => {
  window.removeEventListener('click', clickOutside);
});

onMounted(() => {
  authCheck(props.user);
  window.addEventListener('click', clickOutside);
  if (props.viewMode == 0) {
    if (props.isError == false) {
      callSound(config.SPAPP_SOUND['通常']);
      showMedicineDialog();
    } else {
      callSound(config.SPAPP_SOUND['エラー']);
    }
  } else if (props.viewMode == 2) {
    showSelfInputDialog();
  }
  setSelectWholesalerId(pharamcyMedicineId.value);
});
const callDeviceBarcode = () => {
  //バーコード呼び出し
  callBarcode(config.SPAPP_MENU['発注'])
}
//////// 医薬品情報 //////////////////
const isMedicineDialog = ref(false);
const orderNumber = ref(0);
const onChangeOrderNumber = (value) => {
  orderNumber.value = value;
}
const showMedicineDialog = () => {
  if (orderMedicine.length > 0) {
    isMedicineDialog.value = true;
  }
}
const closeMedicineDialog = () => {
  isMedicineDialog.value = false;
}
const addVanMedicine = () => {
  if (orderMedicine.length == 0) {
    errorAlertApp('選択してください。');
    return;
  }
  if (!selectWholesalerId.value) {
    errorAlertApp('取引卸を選択してください。');
    return;
  }
  if (!orderNumber.value) {
    errorAlertApp('発注数を入力してください。');
    return;
  }
  for (let i=0;i<orderMedicine[0].pharmacy_medicine_list.length;i++) {
    if (orderMedicine[0].pharmacy_medicine_list[i].id == pharamcyMedicineId.value) {
      let record = deepCopy(orderMedicine[0].pharmacy_medicine_list[i]);
      //既存で同じ取引先がある場合は上書きする
      let exist_record = order.search_data('is_auto',pharamcyMedicineId.value,'pharmacy_medicine_id',{wholesaler_id:selectWholesalerId.value});
      if (exist_record == null) {
        record.tmp_id = String(uuid.v4());
      } else {
        record.tmp_id = exist_record.tmp_id;
      }
      record.select_datetime = new Date();
      record.pharmacy_medicine_id = pharamcyMedicineId.value;
      record.stock_type = config.STOCK_TYPES['VAN'];
      record.lot_number = Number(orderNumber.value);
      record.wholesaler_id = selectWholesalerId.value;
      record.tags = deepCopy(orderMedicine[0].tags);
      record.commited = true;
      order.save_data('is_auto',record,'tmp_id');
      break;
    }
  }
  closeMedicineDialog();
}
/////////////////////////////////////
const getPharmacyMedicineList = () => {
  let result = null;
  if (orderMedicine.length > 0) {
    for (let i=0;i<orderMedicine.length;i++) {
      for (let j=0;j<orderMedicine[i].pharmacy_medicine_list.length;j++) {
        if (orderMedicine[i].pharmacy_medicine_list[j].id == pharamcyMedicineId.value) {
          result = orderMedicine[i].pharmacy_medicine_list[j];
          break;
        }
      }
      if (result) {
        break;
      }
    }
  }
  return result;
}
const medicineName = computed(() => {
  let result = '';
  let record = getPharmacyMedicineList();
  if (record != null) {
    result = record.product_name	 + ' ' + record.warning_mark;
  }
  return result;
})

const isVitalWait = computed(() => {
  let result = false;
  let record = getPharmacyMedicineList();
  if (record != null) {
    result = record.is_vital_wait;
  }
  return result;
})
const vitalRelaceCount = computed(() => {
  let result = 0;
  let record = getPharmacyMedicineList();
  if (record != null) {
    result = record.replace_count;
  }
  return result;
})
const vitalChemicalCode = computed(() => {
  let result = 0;
  let record = getPharmacyMedicineList();
  if (record != null) {
    result = record.chemical_code;
  }
  return result;
})

const transitionalMeasureDate = computed(() => {
  let result = '';
  if (orderMedicine.length > 0) {
    for (let i=0;i<orderMedicine.length;i++) {
      for (let j=0;j<orderMedicine[i].pharmacy_medicine_list.length;j++) {
        if (orderMedicine[i].pharmacy_medicine_list[j].id == pharamcyMedicineId.value) {
          result = orderMedicine[i].pharmacy_medicine_list[j].transitional_measure_date;
          break;
        }
      }
      if (result) {
        break;
      }
    }
  }
  return result;
})

const realStockNumber = computed(() => {
  let result = '';
  if (orderMedicine.length > 0) {
    result = orderMedicine[0].real_stock_number.toLocaleString() + orderMedicine[0].package_unit;
  }
  return result;
})
const stockNumber = computed(() => {
  let result = '';
  if (orderMedicine.length > 0) {
    result = orderMedicine[0].stock_number.toLocaleString() + orderMedicine[0].package_unit;
  }
  return result;
})
const prescriptPredictQuantityNumber = computed(() => {
  let result = '';
  if (orderMedicine.length > 0) {
    result = orderMedicine[0].prescript_predict_quantity_number.toLocaleString() + orderMedicine[0].package_unit;
  }
  return result;
})
const wholesalerList = computed(() => {
  let result = [];
  if (orderMedicine.length > 0) {
    result = getPharmacyWholesalerList(orderMedicine[0],pharamcyMedicineId.value);
  }
  if (result.length == 0) {
    result = props.wholesalers;
  }
  return result;
});
const getPharamcyMedicineList = () => {
  let result = [];
  if (orderMedicine.length > 0) {
    result = orderMedicine[0].pharmacy_medicine_list;
  }
  return result;
}
const pharamcyMedicineList = computed(() => {
  return getPharamcyMedicineList();
})
const oldMedicineGroupCount = computed(() => {
  let result = 0;
  if (orderMedicine.length > 0) {
    for (let i=0;i<orderMedicine[0].pharmacy_medicine_list.length;i++) {
      if (orderMedicine[0].pharmacy_medicine_list[i].old_medicine_group_count > 0) {
        result = orderMedicine[0].pharmacy_medicine_list[i].old_medicine_group_count;
        break;
      }
    }
  }
  return result;
})
const oldMedicineCount = computed(() => {
  let result = 0;
  if (orderMedicine.length > 0) {
    for (let i=0;i<orderMedicine[0].pharmacy_medicine_list.length;i++) {
      if (orderMedicine[0].pharmacy_medicine_list[i].old_medicine_count > 0) {
        result = orderMedicine[0].pharmacy_medicine_list[i].old_medicine_count;
        break;
      }
    }
  }
  return result;
})
const packageUnit = computed(() => {
  let result = '';
  if (stockType.value == config.STOCK_TYPES['VAN']) {
    result = '';
  } else {
    if (orderMedicine.length > 0) {
      result = orderMedicine[0].package_unit;
    }
  }
  return result;
})
const isExpensive = computed(() => {
  return (pharmacyMedicineId) => {
    let result = false;
    if (pharamcyMedicineId > 0) {
      if (orderMedicine.length > 0) {
        for (let i=0;i<orderMedicine[0].pharmacy_medicine_list.length;i++) {
          if (orderMedicine[0].pharmacy_medicine_list[i].id == pharmacyMedicineId) {
            result = orderMedicine[0].pharmacy_medicine_list[i].expensive_alert;
            break;
          }
        }
      }
    } else {
      if (orderMedicine.length > 0) {
        for (let i=0;i<orderMedicine[0].pharmacy_medicine_list.length;i++) {
          if (orderMedicine[0].pharmacy_medicine_list[i].expensive_alert) {
            result = true;
            break;
          }
        }
      }
    }
    return result;
  }
})

const isTargetExpensive = computed(() => {
  return (targetPharmacyMedicine) => {
    return targetPharmacyMedicine.expensive_alert;
  }
})
const targetMedicineName = computed(() => {
  return (targetPharmacyMedicine) => {
    let result = '';
    if (targetPharmacyMedicine.stock_type == config.STOCK_TYPES['VAN']) {
      result = targetPharmacyMedicine.product_detail_name + ' ' + targetPharmacyMedicine.warning_mark;
    } else {
      result = targetPharmacyMedicine.medicine.product_detail_name + ' ' + targetPharmacyMedicine.medicine.warning_mark;
    }
    return result;
  }
})
const targetNumber = computed(() => {
  return (targetPharmacyMedicine) => {
    let result = '';
    if (targetPharmacyMedicine.stock_type == config.STOCK_TYPES['VAN']) {
      result = targetPharmacyMedicine.lot_number;
    } else {
      result = targetPharmacyMedicine.number + targetPharmacyMedicine.medicine.package_unit;
    }
    return result;
  }
})

const targetOfferName = computed(() => {
  return (targetPharmacyMedicine) => {
    let result = '';
    if (targetPharmacyMedicine.stock_type == config.STOCK_TYPES['VAN']) {
      for (let i=0;i<props.wholesalers.length;i++) {
        if (props.wholesalers[i].id == targetPharmacyMedicine.wholesaler_id) {
          result = props.wholesalers[i].wholesaler_name;
          break;
        }
      }
    } else {
      result = targetPharmacyMedicine.pharmacy.pharmacy_name;
    }
    return result;
  }
})

const getOrderList = () => {
  let result = [];
  for (let i=0;i<order.edit_order_data.length;i++) {
    result.push(order.edit_order_data[i]);
  }
  for (let i=0;i<order.edit_order_pack_data.length;i++) {
    result.push(order.edit_order_pack_data[i]);
  }
  result.sort((item1,item2) => {
    if (moment(item1.select_datetime).isAfter(moment(item2.select_datetime))){
      return -1;
    } else if (moment(item1.select_datetime).isBefore(moment(item2.select_datetime))){
      return 1;
    }else{
      return 0;
    }
  });
  return result;
}
const orderList = computed(() => {
  return getOrderList();
})
const isExpensiveAlertMessage = computed(() => {
  let message = '';
  let items = getOrderList();
  for (let i=0;i<items.length;i++) {
    if (items[i].expensive_alert) {
      message = '\\' + items[i].expensive_limit_unit_price.toLocaleString();
      break;
    }
  }
  return message;
});

//////////// 卸発注 ///////////////
const selectWholesalerId = ref(0);
const onChangeSelectWholesalerId = (value) => {
  selectWholesalerId.value = Number(value);
}
//////////////////////////////////
////////// 小分け発注 ////////////
const isPharmacyMedicinePackDialog = ref(false);
const pharmacyMeidicinePackIdentityId = ref(0);
const pharmacyPackRef = ref();
const showPharmacyMedicinePackDialog = async () => {
  isPharmacyMedicinePackDialog.value = true;
  let packMedicineId = 0;
  for (let i=0;i<orderMedicine[0].pharmacy_medicine_list.length;i++) {
    if (orderMedicine[0].pharmacy_medicine_list[i].id == pharamcyMedicineId.value) {
      packMedicineId = orderMedicine[0].pharmacy_medicine_list[i].medicine_id;
      break;
    }
  }
  await pharmacyPackRef.value.showPharmacyMedicinePack(orderMedicine[0].id,packMedicineId,0)
}
const closePharmacyMedicinePackDialog = () => {
  isPharmacyMedicinePackDialog.value = false;
}
const submitPharmacyMedicinePackDialog = async (data) => {
  await pharmacyPackRef.value.orderPharmacyMedicinePack();
}
const submitPharmacyMedicinePack = (data) => {
  let record = data;
  //既存で同じ取引先がある場合は上書きする
  let exist_record = order.search_data('is_auto_pack',record.pharmacy_medicine_id,'pharmacy_medicine_id',{pharmacy_id:data['pharmacy']['id'],medicine_group_id:data['medicine_group_id']});
  if (exist_record == null) {
    record.tmp_id = String(uuid.v4());
  } else {
    record.tmp_id = exist_record.tmp_id;
  }
  record.stock_type = config.STOCK_TYPES['小分け'];
  record.select_datetime = new Date();
  order.save_data('is_auto_pack',record,'tmp_id')
  closePharmacyMedicinePackDialog();
  closeMedicineDialog();
}
/////////////////////////////////
//////////////////////////////////
// 手入力対応
const selectMedicineYjCode = ref('');
const selectMedicineId = ref(0);
const selectPharmacyMedicineId = ref(0);
const selectOrgMedicineOptions = computed(() => {
  let result = [];
  return result;
});
const isSelfInputDialog = ref(false);
const isCheckLoading = ref(false);
const showSelfInputDialog = () => {
  selectMedicineYjCode.value = '';
  selectPharmacyMedicineId.value = 0;
  isSelfInputDialog.value = true;
}
const closeSelfInputDialog = () => {
  isSelfInputDialog.value = false;
}
const onSelectChangeMedicine = (item) => {
  selectMedicineId.value = item.id;
  selectMedicineYjCode.value = item.yj_code;
  selectPharmacyMedicineId.value = item.pharmacy_medicine_id;
}
const selectSelfInputMedicine = async () => {
  await checkPharmacyMedicine();
}
const getPharmacyMedicine = async () => {
  orderMedicine.splice(0);
  isCheckLoading.value = true;
  selectWholesalerId.value = 0;
  try {
    let params = {yj_code:selectMedicineYjCode.value,is_auto_view:1,page_size:1};
    const paramsSerializer = (params) => qs.stringify(params);
    const response = await axios.get(props.apis.pharmacy_order_list,{params:params,paramsSerializer});
    if (response.data.list.length > 0) {
      orderMedicine.push(response.data.list[0]);
      pharamcyMedicineId.value = selectPharmacyMedicineId.value;
      for (let i=0;i<orderMedicine[0].pharmacy_medicine_list.length;i++) {
        if (orderMedicine[0].pharmacy_medicine_list[i].id == selectPharmacyMedicineId.value) {
          selectWholesalerId.value = orderMedicine[0].pharmacy_medicine_list[i].wholesaler_id;
          break;
        }
      }
      closeSelfInputDialog();
      showMedicineDialog();
      closeEditVitalWaitMedicine();
    } else {
      errorAlertApp('マスターに存在しません。運営者にご連絡ください。');
    }
  } finally {
    isCheckLoading.value = false;
  }
}
const checkPharmacyMedicine = async () => {
  isCheckLoading.value = true;
  try {
    let params = {medicine_id:selectMedicineId.value};
    const paramsSerializer = (params) => qs.stringify(params);
    const response = await axios.get(props.apis.pharmacy_medicine_check,{params:params,paramsSerializer});
    if (response.data.check_result == false) {
      let confirmResult = await confirmAlertApp('採用品に登録されていません。新規で登録しますか？');
      if (confirmResult.isConfirmed) {
        await updatePharmacyMedicine();
      }
    } else if (response.data.is_deleted) {
      let confirmResult = await confirmAlertApp('以前にこの採用品を削除しています。再登録してもよろしいですか？');
      if (confirmResult.isConfirmed) {
        await updatePharmacyMedicineRecover();
      }
    } else {
      await getPharmacyMedicine();
    }
  } finally {
    isCheckLoading.value = false;
  }
}

const updatePharmacyMedicine = async () => {
  let params = [];
  params.push({
    medicine_id:selectMedicineId.value,
    wholesalers:[],
    medicine_predict_id:0,
    reference_unit_price:0, // 20241022 未使用に仕様変更
    storage_bin1:'',
    storage_bin2:'',
    storage_bin3:'',
    is_self:false,
    is_replace:null,
    selected:true,
  });
  isCheckLoading.value = true;
  try {
    const responsePharmacyMedicine = await axios(props.apis.pharmacy_medicine_update,{method:"post",data:params});
    if (responsePharmacyMedicine.data.status == 200) {
      selectPharmacyMedicineId.value = responsePharmacyMedicine.data.data[0].id;
      await getPharmacyMedicine();
    }
  } finally {
    isCheckLoading.value = false;
  }
}

const updatePharmacyMedicineRecover = async () => {
  let params = new FormData();
  params.append('medicine_id',selectMedicineId.value);
  isCheckLoading.value = true;
  try {
    const responsePharmacyMedicine = await axios(props.apis.pharmacy_medicine_update_recover,{method:"post",data:params});
    if (responsePharmacyMedicine.data.status == 200) {
      selectPharmacyMedicineId.value = responsePharmacyMedicine.data.data.id;
      await getPharmacyMedicine();
    }
  } finally {
    isCheckLoading.value = false;
  }
}

// 手入力対応
//////////////////////////////////
////////// Vital調整品 ////////////
const isEditVitalWaitMedicineDialog = ref(false);
const isEditVitalWaitMedicineLoading = ref(false);
const vitalYjCode = ref('');
const vitalIdentityId = ref(0);
const vitalMedicineId = ref(0);
const vitalPharmacyMedicineId = ref(0);
const vitalSameCode = ref('');
const vitalApiOptions = reactive(
  {
    relation_pharmacy:1,
    is_alive:1,
    exclude_id_name:'id',
    exclude_ids:[],
    same_code:''
  }
)
const onChangeVitalMedicine = (item) => {
  vitalMedicineId.value = item.id;
  vitalYjCode.value = item.yj_code;
  vitalPharmacyMedicineId.value = item.pharmacy_medicine_id;
}

const showEditVitalWaitMedicine = (chemicalCode) => {
  if (!chemicalCode) {
    errorAlertApp('参考類似品がありません。');
    return;
  }
  vitalSameCode.value = chemicalCode;
  vitalApiOptions.same_code = '';
  vitalApiOptions.exclude_ids.splice(0);
  let record = getPharmacyMedicineList();
  if (record != null) {
    vitalApiOptions.same_code = record.chemical_code;
    vitalApiOptions.exclude_ids.push(record.medicine_id);
  }
  vitalIdentityId.value++;
  isEditVitalWaitMedicineDialog.value = true;
}
const closeEditVitalWaitMedicine = () => {
  isEditVitalWaitMedicineDialog.value = false;
}
const updateSameMedicine = async () => {
  selectMedicineYjCode.value = vitalYjCode.value;
  selectMedicineId.value = vitalMedicineId.value;
  selectPharmacyMedicineId.value = vitalPharmacyMedicineId.value;
  isEditVitalWaitMedicineLoading.value = true;
  try {
    await selectSelfInputMedicine();
  } finally {
    isEditVitalWaitMedicineLoading.value = false;
  }
}
/////////////////////////////////
/////// カート機能 ///////////////
const isCartSaveDialog = ref(false);
const isCartSaveDialogLoading = ref(false);
const showCartSaveDialog = () => {
  isCartSaveDialog.value = true;
}
const closeCartSaveDialog = () => {
  isCartSaveDialog.value = false;
}
const saveCart = async () => {
  isCartSaveDialogLoading.value = true;
  let params = order.create_order_params();
  try {
    const response = await axios(props.apis.pharmacy_medicine_cart_update,{method:"post",data:params});
    if (response.data.status == 200) {
      if (response.data.message.length > 0) {
        let alertMessage = '以下の採用品は既にカートに登録済みだったため除外されました。<br>';
        alertMessage += response.data.message.replace(/\n/, '<br>');
        await successAlertApp(alertMessage);
        screenTransition(config.SPAPP_MENU['HOME']);
      } else {
        //TOP画面に遷移
        screenTransition(config.SPAPP_MENU['HOME']);
      }
    }
  } finally {
    isCartSaveDialogLoading.value = false;
  }
}
/////////////////////////////////
</script>

<style scoped>
table td,th {
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
}
table {
  width:100%;
  border-collapse:collapse;
  border: 1px solid #ccc;
}
table > thead > tr {
  border-bottom:2px solid #ccc;
}
table > thead > tr > th {
  padding:0.5em;
  border-right:2px solid #ccc;
  background-color: #000;
  color:#fff;
}
table > tbody > tr {
  border-bottom:1px solid #ccc;
}
table > tbody > tr > td {
  padding:0.5em;
  border-right:1px solid #ccc;
}

.medicine-body {
  height: 100%;
  margin-bottom: 1.0rem;
}
.button {
  background-color:#F59E12;
  color:white;
  width:100%;
  border-radius: 0.5em;
  padding:0.5em 3em 0.5em 3em;
}
.submit-button {
  background-color: #1235F5;
  color: white;
  color:white;
  width:100%;
  border-radius: 0.5em;
  padding:0.5em 3em 0.5em 3em;
}
.submit-button.second {
  background-color: #9e9503;
}
</style>
<template>
<div class="relative">
  <div class="w-full p-2">
    <div class="overflow-y-auto list mb-2" style="height:70vh;">
      <table>
        <thead>
          <tr>
            <th>品名</th>
            <th>取引先</th>
            <th>数量</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="orderData in orderList" :key="orderData.tmp_id">
            <td>
              <span v-html="targetMedicineName(orderData)"></span>
              <span v-show="isTargetExpensive(orderData)" class="ml-2"><img class="w-6 h-6" src="../../../public/images/icon/expensive_alert.png"></span>
              <div v-if="typeof orderData.tags !== 'undefined' && orderData.tags.length > 0">
                <pharmacy-medicine-tag-component
                  :tags="orderData.tags"
                  :apis="apis"
                  :pharmacy-medicine-id="0"
                  :is-edit="false"
                ></pharmacy-medicine-tag-component>
              </div>
            </td>
            <td>{{ targetOfferName(orderData) }}</td>
            <td class="text-center">{{ targetNumber(orderData) }}</td>
            <td class="text-center"><span @click="deleteOrderMedicineConfirm(orderData.stock_type,orderData.tmp_id)"><i class="text-red-500 fa-sharp fa-regular fa-circle-xmark text-3xl"></i></span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mb-4">
      <button type="button" @click="callDeviceBarcode()" class="button">バーコード読み込み</button>
    </div>
    <div class="mb-4">
      <button type="button" @click="showOrderDialog()" class="submit-button">即時発注</button>
    </div>
    <div class="mb-8">
      <button type="button" @click="showCartSaveDialog()" class="submit-button second">発注依頼保存</button>
    </div>
  </div>
</div>
<modal-app-dialog
  :is-visible="isMedicineDialog"
  :close="closeMedicineDialog"
  :submit="addVanMedicine"
  cancel-button-name="閉じる"
  submit-button-name="追加する"
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="text-lg border-b border-gray-200 pb-1 mb-1">
      <div class="mb-1">
        <span v-html="medicineName"></span>
        <span v-show="isExpensive(pharamcyMedicineId)" class="mx-2"><img class="w-6 h-6" src="../../../public/images/icon/expensive_alert.png"></span>
        <button v-show="isVitalWait" @click="(vitalRelaceCount > 0 ? showEditVitalWaitMedicine(vitalChemicalCode) : '')" class="block relative text-white focus:outline-none bg-red-500 m-1 py-1 px-2 text-xs font-xs rounded-full border border-gray-200 hover:bg-red-400 focus:z-10 focus:ring-4 focus:ring-gray-200">出荷調整中<span v-show="vitalRelaceCount > 0" class="absolute -top-3 -right-1 text-xs border rounded-lg text-white bg-blue-500 border-blue-500">候補ｱﾘ</span></button>
        <div v-show="transitionalMeasureDate" class="text-center w-1/2 text-sm m-1 p-1 rounded-full text-white bg-red-600">{{ '経過措置:' + transitionalMeasureDate }}</div>
        <div v-for="medicineRecord in orderMedicine" :key="medicineRecord.id">
          <div v-if="typeof medicineRecord.tags !== 'undefined' && medicineRecord.tags.length > 0" >
            <pharmacy-medicine-tag-component
              :tags="medicineRecord.tags"
              :apis="apis"
              :pharmacy-medicine-id="0"
              :is-edit="false"
            ></pharmacy-medicine-tag-component>
          </div>
        </div>
      </div>
      <div class="flex flex-row items-center mb-1">
        <div class="w-1/2 border border-gray-400 p-2">
          <div class="relative" v-for="medicineRecord in orderMedicine" :key="medicineRecord.id">
            実在庫:{{ realStockNumber }}
            <a href="javascript:void(0)" class="relative cursor-default mr-2" @click="showHoverPrescript(medicineRecord.yj_code)">
              <i class="fa-solid fa-user"></i>
            </a>
            <div ref="element" v-show="isHoverPrescripFlg" class="absolute top-5 left-0 w-auto" style="z-index:2">
              <prescript-analyze-list-component
                :apis="apis"
                :is-predict-carry="true"
                :yj-code="hoverPrescriptYjCode"
                :identity-id="hoverPrescriptIdentityId"
                :pharmacy-medicine-id="medicineRecord.id"
                :on-predict-cover-complete="onPredictCoverComplete"
              ></prescript-analyze-list-component>
            </div>
          </div>
        </div>
        <div :class="'w-1/2 border border-gray-400 p-2 ' + (realStockNumber != stockNumber ? 'text-red-500' : '')">仮在庫:{{ stockNumber }}</div>
      </div>
      <div class="flex flex-row items-center">
        <div class="w-full border border-gray-400 p-2">予測必要数:{{ prescriptPredictQuantityNumber }}</div>
      </div>
    </div>
    <div class="medicine-body">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>品名</th>
            <th>実在庫</th>
            <th>仮在庫</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="pharmacyMedicineRecord in pharamcyMedicineList" :key="pharmacyMedicineRecord.id">
            <td class="text-center"><input type="radio" name="pharmacy_medicine_radio" :value="pharmacyMedicineRecord.id" v-model="pharamcyMedicineId"></td>
            <td>{{ pharmacyMedicineRecord.package_label }}</td>
            <td>{{ pharmacyMedicineRecord.real_stock_number.toLocaleString() }}{{ pharmacyMedicineRecord.package_unit }}</td>
            <td :class="(pharmacyMedicineRecord.real_stock_number != pharmacyMedicineRecord.stock_number ? 'text-red-500' : '')">{{ pharmacyMedicineRecord.stock_number.toLocaleString() }}{{ pharmacyMedicineRecord.package_unit }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex flex-row items-center mb-4">
      <div class="w-1/2 flex items-center px-4 border border-gray-200 rounded-sm dark:border-gray-700">
          <input id="stock_type_van" v-model="stockType" type="radio" :value="config.STOCK_TYPES['VAN']" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
          <label for="stock_type_van" class="w-full py-4 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">卸</label>
      </div>
      <div class="w-1/2 flex items-center px-4 border border-gray-200 rounded-sm dark:border-gray-700">
          <input id="stock_type_pack" v-model="stockType" type="radio" :value="config.STOCK_TYPES['小分け']" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
          <label for="stock_type_pack" class="w-full py-4 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">小分け<span v-show="oldMedicineCount > 0" :class="'ml-2 text-xs border rounded-lg text-white ' + (oldMedicineGroupCount > 0 ? 'bg-red-500 border-red-500' : 'bg-blue-500 border-blue-500')">{{ (oldMedicineGroupCount > 0 ? 'Gr' : '') }}不動ｱﾘ</span></label>
      </div>
    </div>
    <div v-if="stockType == config.STOCK_TYPES['VAN']" class="border-b border-gray-200 pb-1 mb-1">
      <select-box
        :value="selectWholesalerId"
        :options="wholesalerList"
        list-field-name="wholesaler_name"
        :on-change="onChangeSelectWholesalerId"
        :is-searchable="false"
        font-size="1.0rem"
        place-holder="発注卸を選択"
      ></select-box>
    </div>
    <div v-else class="border-b border-gray-200 pb-1 mb-1">
      <div>
        <a href="javascript:void(0)" @click="showPharmacyMedicinePackDialog" class="block text-white bg-amber-500 hover:bg-amber-600 focus:ring-4 focus:ring-amber-300 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center">小分け発注</a>
      </div>
    </div>
    <div v-if="stockType == config.STOCK_TYPES['VAN']" class="text-sm border-b border-gray-200 pb-1 mb-1 flex flex-row items-center">
      <div class="w-4/5 mr-2">
        <text-box
          :value="orderNumber"
          font-size="1.125rem"
          font-line-height="1.75rem"
          :is-focus-clear="false"
          type="number"
          :on-change="onChangeOrderNumber"
        ></text-box>
      </div>
      <div class="w-1/5 text-lg">{{ packageUnit }}</div>
    </div>
  </div>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isSelfInputDialog"
  :close="closeSelfInputDialog"
  :submit="selectSelfInputMedicine"
  cancel-button-name="キャンセル"
  submit-button-name="発注入力する"
  :is-loading="isCheckLoading"
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="m-1">
      <select-box
        :options="selectOrgMedicineOptions"
        :on-change-object="onSelectChangeMedicine"
        font-size="1.125rem"
        font-line-height="1.75rem"
        list-field-name="product_detail_name"
        list-field-name-option="relation_exists_message"
        list-id-name="id"
        list-height="20em"
        :value="0"
        :api-url="apis.medicine_list"
        place-holder="医薬品名を入力"
        :api-option-fields="{relation_pharmacy:1,is_alive:1,is_except_relation:null}"
      ></select-box>
    </div>
  </div>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isErrorDialog"
  :close="closeErrorDialog"
  cancel-button-name="閉じる"
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="text-lg text-red-700">マスターに存在しません。運営者にご連絡ください。</div>
  </div>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isOrderDialog"
  :close="closeOrderDialog"
  :submit="updateOrderConfirm"
  cancel-button-name="閉じる"
  submit-button-name="登録する"
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="mb-1">
      <div class="flex flex-wrap items-center">
        <div class="m-1">納品日</div>
        <div class="m-1 w-2/3">
          <text-box
            place-holder="納品日を入力"
            :on-change="onChangeDeliveryDate"
            :value="deliveryDate"
            type="date"
          ></text-box>
        </div>
      </div>
      <div class="m-1 text-red-600">※卸からの納品日を翌月付けにしたい場合は日付指定してください。</div>
    </div>
    <div v-show="isExpensiveAlertMessage.length > 0" class="text-bold">
      <span>{{isExpensiveAlertMessage}}を越える発注があります。<img class="inline-block w-6 h-6" src="../../../public/images/icon/expensive_alert.png">マークの発注をご確認ください。</span>
    </div>
  </div>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isPharmacyMedicinePackDialog"
  :close="closePharmacyMedicinePackDialog"
  :submit="submitPharmacyMedicinePackDialog"
  cancel-button-name="キャンセル"
  submit-button-name="追加"
>
  <template v-slot:default>
    <order-pack-component
      ref="pharmacyPackRef"
      :apis="apis"
      :is-sp="true"
      :identity-id="pharmacyMeidicinePackIdentityId"
      :submit="submitPharmacyMedicinePack"
    ></order-pack-component>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isEditVitalWaitMedicineDialog"
  :close="closeEditVitalWaitMedicine"
  :submit="updateSameMedicine"
  cancel-button-name="キャンセル"
  submit-button-name="切り替える"
  :is-loading="isEditVitalWaitMedicineLoading"
>
  <template v-slot:header>
    切替候補追加
  </template>
  <template v-slot:default>
    <select-box
      :options="[]"
      :identity-id="vitalIdentityId"
      :on-change-object="onChangeVitalMedicine"
      list-field-name="product_detail_name"
      list-field-name-option="relation_exists_message"
      list-id-name="id"
      list-height="20em"
      :value="vitalMedicineId"
      :api-url="apis.medicine_list"
      :api-option-fields="vitalApiOptions"
    ></select-box>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isCartSaveDialog"
  :close="closeCartSaveDialog"
  :submit="saveCart"
  cancel-button-name="キャンセル"
  submit-button-name="保存する"
  :is-loading="isCartSaveDialogLoading"
>
  <template v-slot:header>
    発注依頼保存確認
  </template>
  <template v-slot:default>
    <p>発注依頼を保存しますか？</p>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isLoading"
  cancel-button-name=""
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="text-md">登録中です。しばらくお待ちください。</div>
  </div>
  </template>
</modal-app-dialog>

</template>

